<template>
    <div
        class="relative flex items-stretch rounded-2xl border-platinum border bg-light-gray p-1 text-center text-dark-gray cursor-pointer"
        @click.prevent="toggleOption"
    >
        <div
            class="selector"
            :class="{
                'translate-x-full': selectedOption === 'packs',
            }"
        />
        <div
            v-for="option in options"
            :key="option.label"
            class="z-10 flex flex-1 flex-col items-center transition-colors px-4 py-3 sm:px-6"
            :class="{ 'text-white': selectedOption === option.value }"
        >
            <img class="h-auto w-10 sm:w-12" :src="option.icon" :alt="`${option.label} icon`" />
            <p class="mb-1 mt-2 font-semibold sm:text-lg">{{ option.label }}</p>
        </div>
    </div>
</template>
<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue'

type PricingOption = 'single' | 'packs'

type Option = {
    value: PricingOption
    label: string
    icon: string
}

const options: Option[] = [
    {
        value: 'single',
        label: 'Single Thankbox',
        icon: '/img/emojis/emoji-greeting-card.svg',
    },
    {
        value: 'packs',
        label: 'Save with Packs',
        icon: '/img/emojis/emoji-photo-stack.svg',
    },
]

const selectedOption = ref<PricingOption>('single')

function updateVisibility() {
    const singleOption = document.getElementById('pricing-single')
    const packOption = document.getElementById('pricing-packs-parent')

    if (selectedOption.value === 'single') {
        singleOption?.classList?.remove('hidden')
        packOption?.classList?.add('hidden')
        history.replaceState(history.state, '', location.pathname + location.search)
    } else {
        singleOption?.classList?.add('hidden')
        packOption?.classList?.remove('hidden')
        history.replaceState(history.state, '', '#pricing-packs')
    }
}

const toggleOption = (): void => {
    const currentIndex = options.findIndex(option => option.value === selectedOption.value)
    const nextIndex = (currentIndex + 1) % options.length
    selectedOption.value = options[nextIndex].value

    updateVisibility()
}

onMounted(() => {
    if (window.location.hash === '#pricing-packs') {
        selectedOption.value = 'packs'
    }

    // listen to window history changes and show the correct option when has changes
    window.addEventListener('hashchange', () => {
        if (window.location.hash === '#pricing-packs') {
            selectedOption.value = 'packs'

            updateVisibility()
            nextTick(() => {
                document.getElementById('pricing-packs')?.scrollIntoView()
            })
        }
    })

    nextTick(() => {
        updateVisibility()
    })
})
</script>
<style scoped>
.selector {
    @apply absolute inset-y-0 left-0 m-1.5 rounded-xl bg-purple transform;
    width: calc(50% - 0.375rem);
    transition:
        transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
        border-radius 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
